const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
const MAX_ATTACHMENT_SIZE_MB = 25;

/**
 * Maximum allowed size for a task attachment, shared across every platform.
 *
 * Validated client-side before uploading to give immediate feedback and avoid
 * large requests the backend would reject anyway.
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export const MAX_ATTACHMENT_SIZE_BYTES = MAX_ATTACHMENT_SIZE_MB * BYTES_PER_MB;
